import { takeEvery } from 'redux-saga/effects';

import * as basketActions from 'store/modules/basket';
import { cancelDiscount } from './utils';

export default function* listenCancelDiscount() {
  yield takeEvery(basketActions.cancelDiscount.toString(), cancelDiscount);
}
